import type {leadContactsRouteApi} from "./-route-api";

import {tableURLStateSchema} from "@project/components/data-display/table";
import {z} from "zod";

export const leadContactsSearchSchema = tableURLStateSchema.extend({
  includeDeleted: z.boolean().optional().default(false),
});

export type LeadContactsSearch = z.output<typeof leadContactsSearchSchema>;
export type LeadContactsNavigateFn = ReturnType<typeof leadContactsRouteApi.useNavigate>;
